<div class="css_mkTable" style="--mkt-color: {{color}};--mkt-color-btn: {{color == '#c2c5cf' ? 'var(--dark)' : color}};--mkt-scroll: {{color}}66;">
    <div class="_body">
        <ng-content></ng-content>
    </div>
    <!-- INPUT -->
    <mkt-input *ngIf="input" (onChange)="addItem($event)"></mkt-input>
</div>
<!-- <mkt-dropdown></mkt-dropdown> -->
<!-- <div class="__overlay"></div> -->